import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function SignOutIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="SignOutIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="Icon_akar-sign-out"
                d="M12.746,12.581h7.974m0,0L17.767,9.037m2.953,3.544-2.953,3.544M13.632,8.151V6.533a1.772,1.772,0,0,0-1.919-1.766l-7.088.59A1.772,1.772,0,0,0,3,7.123V18.038A1.772,1.772,0,0,0,4.625,19.8l7.088.591a1.772,1.772,0,0,0,1.919-1.767V17.011"
                transform="translate(-2.5 -4.26)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
